export default __webpack_public_path__ + "static/media/showcase-entrepreneurship.17eae399.jpg";